import Alert from "../components/ui/alert/Alert";
import { useStoreSelector } from "../hooks/useStoreFromContext";
import { AppState } from "../store";
import useResendConfirmationWithToken from '../hooks/Auth/useResendConfirmationWithToken';
import { useToast } from "../context/ToastContext";

const EmailConfirmationWidget = () => {
  const user = useStoreSelector((s: AppState) => s.user);
  const toast = useToast();

  const { resendConfirmationWithToken } = useResendConfirmationWithToken({
    onCompleted: ({alreadySent, message, success}) => {
      if (success) {
        if (alreadySent) return toast.warning(message)
        return toast.success(message)
      }
    },
    onError: (err) => {
      if (err) return toast.error(String(err)); 
    }, 
    mutationOptions: { awaitRefetchQueries: true }
  });

  if (!user || user.userConfirmed) return null;

  const resendConfirmation = async () => {
    await resendConfirmationWithToken({
      email: user.email
    });
  }

  return (
    <div className="mx-auto w-full max-w-60 gap-2 py-3 sm:gap-4 lg:px-0">      
      <Alert 
        variant='warning' 
        title='Email Not Confirmed'
        message='Please confirm your email address to access all features of GetEat.'
        showLink
        linkText='Resend Email Confirmation'
        onClick={resendConfirmation}
      />
    </div>
  );
}

export default EmailConfirmationWidget;
